import { combineReducers, Reducer } from 'redux';
import { reducer as deliveredOrdersReducer } from 'b2b-apps/shop/myAccount/deliveredOrders/redux/deliveredOrders/reducer';
import { reducer as deliveredOrdersSearchReducer } from 'b2b-apps/shop/myAccount/deliveredOrders/redux/deliveredOrdersSearch/reducer';
import { DeliveredOrdersAction, DeliveredOrdersState } from './types';

const reducer: Reducer<DeliveredOrdersState, DeliveredOrdersAction> = combineReducers({
  deliveredOrders: deliveredOrdersReducer,
  deliveredOrdersSearch: deliveredOrdersSearchReducer,
});

export { reducer };
